import { AdministratorsViewComponent } from './administrators-view/administrators-view.component';

export const AllContainers = [
  AdministratorsViewComponent
];

export * from './administrators-view/administrators-view.component';
